"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withV3RealmConfigAccount = exports.withTokenConfigAccounts = exports.createRealmConfigArgs = void 0;
var constants_1 = require("../registry/constants");
var accounts_1 = require("./accounts");
var enums_1 = require("./enums");
function assertValidTokenConfigArgs(programVersion, tokenConfigArgs, tokenKind) {
    if (tokenConfigArgs) {
        if (programVersion < constants_1.PROGRAM_VERSION_V2) {
            throw new Error("Governing token config is not supported in version ".concat(programVersion));
        }
        else if (programVersion == constants_1.PROGRAM_VERSION_V2) {
            if (tokenKind == enums_1.GoverningTokenRole.Council) {
                throw new Error("Council token config is not supported in version ".concat(programVersion));
            }
            if (tokenConfigArgs.tokenType != accounts_1.GoverningTokenType.Liquid) {
                throw new Error("Community token type ".concat(tokenConfigArgs.tokenType, " is not supported in veriosn ").concat(programVersion));
            }
        }
    }
}
function createRealmConfigArgs(programVersion, councilMint, communityMintMaxVoteWeightSource, minCommunityWeightToCreateGovernance, communityTokenConfig, councilTokenConfig) {
    var _a, _b;
    assertValidTokenConfigArgs(programVersion, communityTokenConfig, enums_1.GoverningTokenRole.Community);
    assertValidTokenConfigArgs(programVersion, councilTokenConfig, enums_1.GoverningTokenRole.Council);
    return new accounts_1.RealmConfigArgs({
        useCouncilMint: councilMint !== undefined,
        minCommunityTokensToCreateGovernance: minCommunityWeightToCreateGovernance,
        communityMintMaxVoteWeightSource: communityMintMaxVoteWeightSource,
        // VERSION == 2
        useCommunityVoterWeightAddin: (communityTokenConfig === null || communityTokenConfig === void 0 ? void 0 : communityTokenConfig.voterWeightAddin) !== undefined,
        useMaxCommunityVoterWeightAddin: (communityTokenConfig === null || communityTokenConfig === void 0 ? void 0 : communityTokenConfig.maxVoterWeightAddin) !== undefined,
        // VERSION >= 3
        communityTokenConfigArgs: new accounts_1.GoverningTokenConfigArgs({
            useVoterWeightAddin: (communityTokenConfig === null || communityTokenConfig === void 0 ? void 0 : communityTokenConfig.voterWeightAddin) !== undefined,
            useMaxVoterWeightAddin: (communityTokenConfig === null || communityTokenConfig === void 0 ? void 0 : communityTokenConfig.maxVoterWeightAddin) !== undefined,
            tokenType: (_a = communityTokenConfig === null || communityTokenConfig === void 0 ? void 0 : communityTokenConfig.tokenType) !== null && _a !== void 0 ? _a : accounts_1.GoverningTokenType.Liquid,
        }),
        councilTokenConfigArgs: new accounts_1.GoverningTokenConfigArgs({
            useVoterWeightAddin: (councilTokenConfig === null || councilTokenConfig === void 0 ? void 0 : councilTokenConfig.voterWeightAddin) !== undefined,
            useMaxVoterWeightAddin: (councilTokenConfig === null || councilTokenConfig === void 0 ? void 0 : councilTokenConfig.maxVoterWeightAddin) !== undefined,
            tokenType: (_b = councilTokenConfig === null || councilTokenConfig === void 0 ? void 0 : councilTokenConfig.tokenType) !== null && _b !== void 0 ? _b : accounts_1.GoverningTokenType.Liquid,
        }),
    });
}
exports.createRealmConfigArgs = createRealmConfigArgs;
function withTokenConfigAccounts(keys, communityTokenConfig, councilTokenConfig) {
    if (communityTokenConfig === null || communityTokenConfig === void 0 ? void 0 : communityTokenConfig.voterWeightAddin) {
        keys.push({
            pubkey: communityTokenConfig.voterWeightAddin,
            isWritable: false,
            isSigner: false,
        });
    }
    if (communityTokenConfig === null || communityTokenConfig === void 0 ? void 0 : communityTokenConfig.maxVoterWeightAddin) {
        keys.push({
            pubkey: communityTokenConfig.maxVoterWeightAddin,
            isWritable: false,
            isSigner: false,
        });
    }
    if (councilTokenConfig === null || councilTokenConfig === void 0 ? void 0 : councilTokenConfig.voterWeightAddin) {
        keys.push({
            pubkey: councilTokenConfig.voterWeightAddin,
            isWritable: false,
            isSigner: false,
        });
    }
    if (councilTokenConfig === null || councilTokenConfig === void 0 ? void 0 : councilTokenConfig.maxVoterWeightAddin) {
        keys.push({
            pubkey: councilTokenConfig.maxVoterWeightAddin,
            isWritable: false,
            isSigner: false,
        });
    }
}
exports.withTokenConfigAccounts = withTokenConfigAccounts;
function withV3RealmConfigAccount(keys, programId, programVersion, realm) {
    return __awaiter(this, void 0, void 0, function () {
        var realmConfigMeta;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(programVersion >= constants_1.PROGRAM_VERSION_V3)) return [3 /*break*/, 2];
                    _a = {};
                    return [4 /*yield*/, (0, accounts_1.getRealmConfigAddress)(programId, realm)];
                case 1:
                    realmConfigMeta = (_a.pubkey = _b.sent(),
                        _a.isSigner = false,
                        _a.isWritable = true,
                        _a);
                    keys.push(realmConfigMeta);
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
exports.withV3RealmConfigAccount = withV3RealmConfigAccount;
//# sourceMappingURL=tools.js.map